"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const INDENT_REG = /^\s*/;
const SUFFIX_SPACE_REG = /\s+$/;
/**
 * Template function that strips the indentation from a tagged template string
 *  based on the first non empty line
 *
 * Usage:
 *
 * textBlock`
 *     Multi-line text
 *
 *     With paragraphs that streatch
 *         long and wide
 *         and deep into the ocean
 * `
 */
function textBlock(list, ...args) {
    const content = new Array(list.length + args.length);
    if (list.length === 1)
        content.push(list[0]);
    else {
        for (let i = 0; i < list.length; ++i) {
            content[i * 2] = list[i];
            content[i * 2 + 1] = args[i];
        }
    }
    const lines = content.join('').split('\n');
    // remove all starting and trailing empty lines
    while (lines.length) {
        if (lines[lines.length - 1].trim().length === 0)
            lines.pop();
        else if (lines[0].trim().length === 0)
            lines.shift();
        else
            break;
    }
    // Measure indentation from the template literal parts only, before interpolation.
    //  A multi-line interpolated value carries its own indentation baseline (unrelated to
    //  the template); including it here would let a small interpolated indent become the
    //  minimum, under-stripping the surrounding template and flattening the interpolated block.
    const templateLines = list.join('').split('\n');
    let minIndent = null;
    const measure = (arr) => {
        for (let i = 0; i < arr.length; ++i) {
            const line = arr[i];
            const [indent] = line.match(INDENT_REG);
            if (indent.length === line.length)
                continue; // ignore all whitespace lines
            if (minIndent == null || indent.length < minIndent.length)
                minIndent = indent;
            if (minIndent.length === 0)
                return;
        }
    };
    measure(templateLines);
    // If the template carries no structural indent of its own (e.g. `textBlock`${value}``),
    //  fall back to measuring the assembled content so a lone interpolated value still dedents.
    if (minIndent == null)
        measure(lines);
    const stripIndentReg = new RegExp(`^${minIndent !== null && minIndent !== void 0 ? minIndent : ''}`);
    const result = [];
    for (let i = 0; i < lines.length; ++i) {
        const line = lines[i];
        const stripped = line.replace(stripIndentReg, '').replace(SUFFIX_SPACE_REG, '');
        result.push(stripped);
    }
    return result.join('\n');
}
exports.default = textBlock;
//# sourceMappingURL=index.js.map